import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import type { SchemaPartnerResolver_GetPartnersArgs } from './getPartners';

// Same args as getPartners so list and count can never diverge; limit/offset/sort are ignored.
type Arguments = Partial<Record<keyof SchemaPartnerResolver_GetPartnersArgs, unknown>>;

export const schemaPartnerResolver_GetPartnersCount = z.number();

export type SchemaPartnerResolver_GetPartnersCount = z.infer<typeof schemaPartnerResolver_GetPartnersCount>;
export type PartnerResolver_GetPartnersCount = Resolver<Arguments, SchemaPartnerResolver_GetPartnersCount>;
